"use client";

import { MapPinned } from "lucide-react";
import { useTranslations } from "next-intl";
import React, { type HTMLAttributes, type ReactElement } from "react";
import { ObservatoryStat } from "@/components";
import type { Observatory } from "@/types";
import Link from "next/link";
import { getApplication } from "@/services/applications";

interface ObservatoryStatSiteProps extends HTMLAttributes<HTMLDivElement> {
  observatory: Observatory;
}

function ObservatoryStatSite({
  observatory,
}: Readonly<ObservatoryStatSiteProps>): ReactElement | null {
  const t = useTranslations("global.ObservatoryStat");
  const application = getApplication("sites");
  const route = `${application?.url}/?monitoring=${observatory.id}`;

  if (observatory.stat?.site) {
    return (
      <Link href={route}>
        <ObservatoryStat
          number={observatory.stat.site}
          label={t("site", { count: observatory.stat.site })}
          icon={<MapPinned strokeWidth={1} />}
        />
      </Link>
    );
  }

  return null;
}

export { ObservatoryStatSite, type ObservatoryStatSiteProps };
